import s from "../../categoriesFormTree.module.css";
import {typeClinicalAnalysis, typeVaccine, typeVaccineCombo} from "../../../../../assets";
import { useAppContext } from "../../../../../contexts";

const ChildCategory = props => {
    // Destructured props
    const {
        index,
        selectedCategories,
        parentCategory,
        childCategory,
        handleChange,
        additionalCategories
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Dynamically updates the input name
    const NAME =
        !additionalCategories.includes(parentCategory.id) ?
            "base-category" :
            `additional-category-${parentCategory.id}`;

    // Checks whether input should be checked or not
    const isChecked = selectedCategories.get(NAME) === childCategory.id;

    // An enum for all the icon types
    const serviceTypeIconEnum = {
        vaccine_combo: typeVaccineCombo,
        vaccine: typeVaccine,
        clinical_analysis: typeClinicalAnalysis
    }

    return (
        <fieldset className={`flex flex-row gap-x-2.5 items-center cursor-pointer ${s.fieldset}`}>
            <input
                id={`${index}-cat-${childCategory.id}`}
                name={NAME}
                className={"cursor-pointer"}
                type={"radio"}
                checked={isChecked}
                onClick={() => handleChange({
                    category: {
                        root: parentCategory.id,
                        inputName: NAME,
                        ...childCategory
                    }
                })}
            />
            <label 
                htmlFor={`${index}-cat-${childCategory.id}`} 
                className={`${s.catName} ${highContrast ? "text-contrast-yellow hover:text-white" : "text-[#666] hover:text-sabin-red-default"}`}
            >
                {!!serviceTypeIconEnum[childCategory.icon] && (
                    <img
                        src={serviceTypeIconEnum[childCategory.icon]}
                        className={`${s.catIcon} ${highContrast ? "filter grayscale" : ""}`}
                        alt={"Category icon"}
                    />
                )}
                {childCategory.name}
            </label>
        </fieldset>
    )
}

export default ChildCategory;
